"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kelvinToUnit = void 0;
const TemperatureUnit_1 = require("./TemperatureUnit");
function kelvinToUnit(temperature, toUnit) {
    switch (toUnit) {
        case TemperatureUnit_1.TemperatureUnit.Celsius:
            return temperature - 273.15;
        case TemperatureUnit_1.TemperatureUnit.Fahrenheit:
            return (temperature * 9) / 5 - 459.67;
        case TemperatureUnit_1.TemperatureUnit.kelvin:
            return temperature;
    }
}
exports.kelvinToUnit = kelvinToUnit;
//# sourceMappingURL=kelvinToUnit.js.map